import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import classnames from 'classnames';

const SCROLL_DEBOUNCE_TIME = 100;

interface IItemAboveViewport {
    children: JSX.Element | JSX.Element[];
    component: string;
    className?: string;
}

@observer
export class ItemAboveViewport extends React.Component<IItemAboveViewport> {
    private ref: React.RefObject<HTMLDivElement> = React.createRef();
    private scrollTimeout: NodeJS.Timeout | number;
    @observable private isAboveViewPort: boolean;

    componentDidMount() {
        window.addEventListener('scroll', this.scrollHandler);
        this.updateAboveScroll();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollHandler);
    }

    public scrollHandler = () => {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout as number);
        }

        this.scrollTimeout = setTimeout(this.updateAboveScroll, SCROLL_DEBOUNCE_TIME);
    };

    @action
    public updateAboveScroll = () => {
        const { top = 0 } = this.ref.current?.getBoundingClientRect() || {};

        this.isAboveViewPort = top < 0;
    };

    render() {
        const componentClassName = classnames(
            this.props.className,
            this.isAboveViewPort && `elc-${this.props.component}--is-above-viewport`
        );

        return (
            <div className={componentClassName} ref={this.ref}>
                {this.props.children}
            </div>
        );
    }
}
